export class ScriptDTO {

    constructor(
      readonly actualName: string,
      readonly newName: string,
      readonly script: string,
      readonly isRenameRequest?: boolean,
    ) {
    }
  }